import { Component, inject, OnInit } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { Catalog } from '../../../Model/Catalog/Catalog';
import { FeatureSystem } from '../../../Model/Catalog/FeatureModels/FeatureSystem';
import { Message } from "../../../Model/System/Message";
import { StartAction } from '../../../Model/Dto/StartAction';
import { UserManagementService } from "../../../Services/userManagment.service";
import { Product } from "../../../Model/Catalog/Product";
import { ClassificationClass } from "../../../Model/classification/ClassificationClass";
import { ClassificationService } from "../../../Services/classification.service";
import { AddClassification } from "../../../Model/classification/AddClassification";
import { NpInputControlContext } from "../../../ui/inputControl/np-input-control-context";
import { WawiSettingsService } from "../../../Services/wawiSettingsService.service";
import { LoginService } from "../../../Services/login.service";
import { CatalogService } from "../../../Services/CatalogManagement/catalog.service";
import { JobService } from "../../../Services/job.service";
import { SystemService } from "../../../Services/system.service";


@Component({
    selector: "catalogTemplates",
    templateUrl: "catalogTemplates.component.html",
    styleUrls: [],
    standalone: false,
    providers: [NpInputControlContext]
})
export class CatalogTemplatesComponent implements OnInit {
    wawiDummyProduct: Product;
    textsDummyProduct: Product;
    legalDummyProduct: Product;

    private textsContext = inject(NpInputControlContext);

    constructor(public translate: TranslateService, public catalogService: CatalogService,
                public userManagement: UserManagementService, public classificationService: ClassificationService,
                public wawiSettingsService: WawiSettingsService, public loginService: LoginService,
                public systemService: SystemService, public jobService: JobService) {
        this.applyTemplate = this.applyTemplate.bind(this);

        this.wawiDummyProduct = new Product();
        this.wawiDummyProduct.wawi = this.model.wawiTemplate;

        this.textsDummyProduct = new Product();

        this.legalDummyProduct = new Product();
        this.legalDummyProduct.legalCharacteristic = this.model.legalTemplate;
    }

    ngOnInit(): void {
        this.translateTexts();
        this.reset();
        this.setupTextsContext();
        this.fillDummyProductWawi();
    }

    private setupTextsContext(): void {
        this.textsDummyProduct.featureSystems = this.model.featureTemplate;
        this.textsContext.model = this.textsDummyProduct;
        this.textsContext.showLinkButtons = false;
        this.textsContext.valueChanged.subscribe(() => {
            this.model.featureTemplate = this.textsDummyProduct.featureSystems;
            this.catalogUpdate();
        });
    }


    txtTextsTemplate: string = "";
    txtFeatureTemplate: string;
    txtMediaTemplate: string;
    txtMakroGestarted: string;

    get model(): Catalog {
        return this.catalogService.catalog;
    }

    set model(catalog: Catalog) {
        this.catalogService.catalog = catalog;
    }

    catalogUpdate(event = null) {
        this.catalogService.updateCatalog();
    }

    reload() {
        this.catalogService.treeRefresh();
        this.catalogService.getCatalog(this.catalogService.catalog.id, this.loginService.currentUser.customerId).subscribe();
        this.wawiDummyProduct.wawi = this.model.wawiTemplate;
        this.textsDummyProduct.featureSystems = this.model.featureTemplate;
        this.legalDummyProduct.legalCharacteristic = this.model.legalTemplate;
    }

    private translateTexts() {
        this.txtTextsTemplate = this.translate.instant("Texte");
        this.txtFeatureTemplate = this.translate.instant("Merkmale");
        this.txtMediaTemplate = this.translate.instant("Medien");
        this.txtMakroGestarted = this.translate.instant("Die Aktualisierung wurde als Job gestartet");
    }

    pages: { id: number; title: string; template: string }[] = [];

    reset() {
        this.pages = [
            { id: 1, title: this.txtTextsTemplate, template: "textsTemplate" },
            { id: 2, title: this.txtFeatureTemplate, template: "featureTemplate" },
            { id: 3, title: this.txtMediaTemplate, template: "mediaTemplate" },
            { id: 4, title: this.translate.instant("Wawi"), template: "wawiTemplate" },
            { id: 5, title: this.translate.instant("Recht"), template: "legalTemplate" },
        ];

    }

    fillDummyProductWawi() {
        this.wawiDummyProduct.wawi = this.wawiSettingsService.getDefaultWawiIntegration(this.model.wawiTemplate, this.loginService.wawiSettings);
    }

    updateWawi(event = null) {
        this.model.wawiTemplate = this.wawiDummyProduct.wawi;
        this.catalogUpdate();
    }

    updateLegal(event = null) {
        this.model.legalTemplate = this.legalDummyProduct.legalCharacteristic;
        this.catalogUpdate();
    }

    addEcommerceFeatures() {
        this.catalogService.addEcommerceFeaturesToCatalog(this.model).subscribe(
            (catalog: Catalog) => {
                this.model.featureTemplate = catalog.featureTemplate;

            });
    }

    applyTemplate() {

        let startAction = new StartAction();
        startAction.catalogId = this.catalogService.catalog.id;
        startAction.customerId = this.loginService.currentUser.customerId;
        startAction.actionType = "ApplyProductTemplate";

        this.jobService.startUserAction(startAction)
            .subscribe(next => {
                this.systemService.notify(new Message(this.txtMakroGestarted));
            });
    }

    async addClassificationFeatures(event: ClassificationClass) {
        if (!event)
            return;

        let dto = new AddClassification();
        dto.classificationClassId = event.id;
        dto.classificationSystemId = event.classificationSystemId;
        dto.customerId = this.catalogService.catalog.customerId;
        dto.catalogId = this.catalogService.catalog.id;

        var featureSystems = await this.classificationService.addClassificationFeatures(dto);
        this.catalogService.catalog.featureTemplate = new Array<FeatureSystem>();

        let that = this;
        featureSystems.forEach(function (r) {
            let fs = Object.assign(new FeatureSystem(), r);
            that.catalogService.catalog.featureTemplate.push(fs);
        });
    }

    canView(name: string): boolean {
        return this.userManagement.canView(name);
    }

    readOnlyUser(name: string, catalog: Catalog = this.model): boolean {
        return !this.userManagement.canEdit(name, catalog);
    }
}
